import React from "react";
import { MockedProvider } from "@apollo/client/testing";

const wrapTestComponent = ({
  Component,
  addTypeName,
  apolloClient,
  mocks
}) => props => (
  <MockedProvider
    addTypeName={addTypeName}
    cache={apolloClient.cache}
    mocks={mocks}
  >
    <Component {...props} />
  </MockedProvider>
);

export default wrapTestComponent;
